import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { About } from "../components/site/About";
import { Services } from "../components/site/Services";
import { Training } from "../components/site/Training";
import { Products } from "../components/site/Products";
import { Stats } from "../components/site/Stats";
import { Contact } from "../components/site/Contact";

export default function Home() {
  return (
    <div className="min-h-screen bg-white text-slate-900 antialiased">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Training />
        <Products />
        <Stats />
        <Contact />
      </main>
    </div>
  );
}
